import UsuarioCoverService from 'business/cadastro/pessoa/usuarioCover/usuarioCoverService'
import { errorToToast } from 'helper/error'
import server from 'infra/server'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as auth from "infra/localStorage.js"
import { MD5 } from 'crypto-js'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { getMask } from 'helper/formater'
import { addConfirmTag, addRequestTag, getCustomPresignedPost } from 'helper/bucket'
import ModalCropper from 'base/cropper/modalCropper/ModalCropper'

export default function UsuarioCover(props) {

    const [service] = useState(() => new UsuarioCoverService())  // Inicializa o service uma vez

    const [avatarImage, setAvatarImage] = useState(null)
    const [binaryImage, setBinaryImage] = useState(null)
    const toast = useRef(null)
    const [validations, setValidations] = useState([])
    const [saving, setSaving] = useState(false)
    const [alterarPwd, setAlterarPwd] = useState(false)
    const [log, setLog] = useState('')
    const [inputKey, setInputKey] = useState(Date.now())

    // Para cropper
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null)

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    useEffect(() => {
        service.getSchema().then(setValidations)
    }, [service])

    function customLog(...value) {

        console.log(...value)

        if ('' === 'debug') {
            let newLog = log + '  '
            value.map(e => newLog += JSON.stringify(e))
            setLog(newLog)
        }

    }

    async function load() {

        return await server().get('cadastro/pessoa/usuariocover').then(async (response) => {

            if (response.data.pessoa_fisica.pessoa.ref_img_pes) {
                const imgUrl = `${auth.getData().bucketPath}/pessoa/${response.data.pessoa_fisica.pessoa.ref_img_pes}`
                setAvatarImage(imgUrl)
            }

            return response.data

        }).catch(err => {

            const storageData = auth.getData()
            const emailMd5 = MD5(storageData.usuario.email_usu)
            setAvatarImage(`https://www.gravatar.com/avatar/${emailMd5}`)
            errorToToast({ err, toast, alt: 'Erro desconhecido' })

        })

    }

    const onSubmit = async (data) => {

        setSaving(true)

        let id = data.codigo_usu
        const dataCopy = { ...data }

        console.log('Saving...')
        service.save(id, dataCopy).then(async (_response) => {

            /**
             * Subir arquivo para o s3 usando post pré-assinado!
             */

            if (binaryImage) {

                id = _response.data.codigo_usu

                form.setValue('codigo_usu', _response.data.codigo_usu)

                dataCopy.codigo_usu = _response.data.codigo_usu

                const post = getCustomPresignedPost({
                    typeName: 'image',
                    presignedPost: _response.data.pessoa_fisica.pessoa.meta.refImgPesPresigned,
                    binaryFile: binaryImage
                })

                const url = post.url + post.fields.key

                try {
                    // Faz o upload para o S3
                    await axios.post(post.url, post.formData, { headers: post.headers }).then(async () => {

                        dataCopy.pessoa_fisica.pessoa.ref_img_pes = addConfirmTag(dataCopy.pessoa_fisica.pessoa.ref_img_pes)

                        dataCopy.meta.alterarPwd = false
                        setAlterarPwd(false)

                        // Resaving...
                        console.log('Re-saving...')
                        await service.save(id, dataCopy).then(async (_response) => {
                            const gravatarUrl = url + `?timestamp=${new Date().getTime()}`
                            props.setGravatar('')
                            props.setGravatar(gravatarUrl)
                            close()
                        }).catch((err) => {
                            errorToToast({ err, toast, alt: 'Erro desconhecido' })
                        })

                    }).catch(err => customLog('Erro inesperado no upload:', err))

                } catch (error) {
                    console.error('Erro ao fazer upload para o S3:', error)
                }

            } else {
                close()
            }
        }).catch((err) => {
            errorToToast({ err, toast, alt: 'Erro desconhecido' })
        }).finally(() => setSaving(false))

    }

    function close() {
        props.setPerfilSidebar(false)
    }

    // Cropper
    const handleImageChange = (event) => {

        const file = event.target.files[0]
        if (file) {
            const url = URL.createObjectURL(file)
            setSelectedImage(url)
            setIsModalVisible(true)
        }

        setInputKey(Date.now())

    }
    const handleSaveCroppedImage = (blob, url) => {

        setAvatarImage(url)
        setBinaryImage(blob)
        form.setValue('pessoa_fisica.pessoa.ref_img_pes', addRequestTag('nameOfFile.png'), { shouldDirty: true })

    }

    return (
        <div >
            <form
                className='flex flex-column gap-2 p-2'
                onSubmit={form.handleSubmit(onSubmit)}
                toast={toast}
            >

                {/* Cropped */}

                <div className="flex flex-column align-items-center gap-2">
                    {avatarImage ? (
                        <img
                            src={avatarImage}
                            alt="Cropped Avatar"
                            style={{ width: 64, height: 64, borderRadius: '50%' }}
                        />
                    ) : (
                        <div style={{ width: 64, height: 64, backgroundColor: '#ccc', borderRadius: '50%' }} />
                    )}
                    <span>{form.getValues('login_usu')}</span>
                    <Button
                        label="Alterar Imagem"
                        icon="pi pi-upload"
                        onClick={(e) => {
                            e.preventDefault()
                            // document.getElementById('upload-input').value = ''
                            document.getElementById('upload-input').click()

                        }}
                        outlined
                    />
                    <input
                        key={inputKey} // inputKey é dinâmica para disparar onChange caso reselecionar imagem
                        id="upload-input"
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={handleImageChange}
                    />
                </div>

                <ModalCropper
                    visible={isModalVisible}
                    onHide={() => setIsModalVisible(false)}
                    image={selectedImage}
                    onSave={handleSaveCroppedImage}
                    croppedConfig={{ width: 64, height: 64 }}
                />

                {/* End cropped */}

                <Toast ref={toast} />
                <GridForm>

                    <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="pessoa_fisica.pessoa.nome_razao_pes" form={form} service={service} type="text" clearString label="Nome" />
                    <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" mask={getMask('cellphone')} field="pessoa_fisica.pessoa.tel_cel_pes" form={form} service={service} type="text" inputMode="tel" label="Celular" />

                    <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="meta.alterarPwd" form={form} service={service} type="switch"
                        label="Alterar senha"
                        onClick={e => setAlterarPwd(e.target.checked)}
                    />

                    <div className='col-12 m-0 p-0' hidden={!alterarPwd} >
                        <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="meta.atualPwd" form={form} service={service} type="password" inputMode="text" label="Senha atual" autoComplete="new-password" />
                        <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="meta.novaPwd" form={form} service={service} type="password" inputMode="text" label="Nova senha" autoComplete="new-password" />
                        <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="meta.repetePwd" form={form} service={service} type="password" inputMode="text" label="Repita nova senha" autoComplete="new-password" />
                    </div>

                </GridForm>

                <Button
                    type='submit'
                    outlined
                    label={saving ? 'Salvar' : 'Salvar'}
                    icon={saving ? "pi pi-spin pi-cog" : "pi pi-save"}
                    onClick={() => {
                        if (form.formState.errors) {
                            customLog('Errors:', form.formState.errors)
                        }
                    }}
                />
                <Button label="Voltar" size="normal" icon="pi pi-arrow-left" severity="success" outlined
                    onClick={e => close()}
                />
            </form>

        </div>
    )
}
